import React from "react";
import ShortlistButton from "../shortlist/shortlist-button";
import Picture from "../media/picture";

export default class CruiseDriver extends React.Component<> {
    constructor(props){
        super(props);

        this.state = {
            grid: this.props.grid
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.state.grid !== nextProps.grid) this.setState({grid: nextProps.grid });
    }

    onEnquiryClick = (e) => {
        window.dataLayer.push({ event: 'cruise_search_enquiry', cruise: this.props.externalId_s, ship: this.props.shipName_s, line: this.props.lineName_s });
        window.location = `/cruise-enquiry/${this.props.slug_s}`;
    }

    renderPrice = () => {
        let wasPrice = null;
        let fromPrice = null;
        let CabinType = null;
        let priceDesc = null;

        if(!this.props.solo) {
            if (this.props.fromPrice_i && this.props.fromPrice_i < 999998) fromPrice = this.props.fromDisplayPrice_s;
            if (this.props.fromPriceWas_i) wasPrice = this.props.fromPriceWas_i;
            if (this.props.fromPriceCabinType_s) CabinType = this.props.fromPriceCabinType_s;
            if (this.props.fromPriceDescription_s) priceDesc = this.props.fromPriceDescription_s;
        } else {
            if (this.props.fromSoloPrice_i && this.props.fromSoloPrice_i < 999998) fromPrice = this.props.fromSoloDisplayPrice_s;
            if (this.props.fromSoloPriceWas_i) wasPrice = this.props.fromSoloPriceWas_i;
            if (this.props.fromSoloPriceCabinType_s) CabinType = this.props.fromSoloPriceCabinType_s;
            if (this.props.fromSoloPriceDescription_s) priceDesc = this.props.fromSoloPriceDescription_s;
        }

        if (fromPrice) return ( <p className="cruise-driver--price-wrapper">
            {wasPrice &&  <s className="was">(full fare £{wasPrice})</s> }
            <span className="price">{CabinType} from <strong dangerouslySetInnerHTML={{__html:fromPrice}} /></span>
            { priceDesc && <span className="offer" dangerouslySetInnerHTML={{__html:priceDesc}} /> }
        </p>);
        
        return <p className="cruise-driver--price-wrapper">
            <span className="price">Call for price <a className="InfinityNumber clickable" href="tel:08082394989">08082394989</a></span>
        </p>; // Infinity tracking
        // return (<span>  Call for price <a title="Call us now to get a price" className="price" href="tel:08002044635"><span className="dniNumber dniPooldefault">0800 204 4636</span></a></span>);
    };

    renderUrl = () => {
        if(this.props.solo) return `/cruise-detail/${this.props.slug_s}?soloPrices=true`
        return `/cruise-detail/${this.props.slug_s}`
    }

    renderDate = () => {
        return (<>{ this.props.departureDay_i } { this.props.departureMonth_s } { this.props.departureYear_i } </>);
    };

    renderIncluded = () => {
        if (this.props.extras_ss) {
            return this.props.extras_ss.map((item) => <p>
                <i className="icn icn-tick" />{item}
            </p>)
        }
        if (this.props.whatsIncluded_ss) {
            return this.props.whatsIncluded_ss.slice(0, 4).map((item) => {
                return <p>
                    <i className="icn icn-tick" />{item}
                </p>
            })
        }
        return '';
    };

    renderLineLogo = () => {
        let logo = () => {
            if(this.props.lineLogo_s && this.props.lineLogo_s.substr(0, 4) !== 'http') {
                return <Picture src={this.props.lineLogo_s} filter={'cruise_driver_line_logo'} alt={this.props.lineName_s}/>
            } else {
                return <img className="lazyload" data-src={this.props.lineLogoUrl_s} alt={this.props.lineName_s} src={this.props.lineLogoUrl_s} data-was-processed="true"/>
            }
        }

        return <a href={`/cruise-lines/${ this.props.lineSlug_s}`} className="cruise-driver--logo-wrapper"> { logo() }</a>
    };

    render(){
        let imageFilter = this.state.grid ? 'cruise_driver' : 'cruise_driver_full';
        return(
            <div className={this.state.grid ? 'cruise-driver ' : 'cruise-driver full'}>
                { this.props.promo_tag_ss && <div className="cruise-driver--banner" style={{color:this.props.promo_tag_colour_s || this.props.tag_colour_s}}>
                    <span className="cruise-driver--banner-text">{ this.props.promo_tag_ss[0] }</span>
                </div> }

                <div className="cruise-driver--top-wrapper">
                    <a title={ `View Cruise ${this.props.name_s}` } className="cruise-driver--image" href={ this.renderUrl() } role="img" aria-label={`View Cruise ${this.props.name_s} Deal`} >
                        <span className="bg-image-anchor-text">View Cruise {this.props.name_s } Deal</span>
                        <Picture src={this.props.listingImage_s} filter={imageFilter}/>
                    </a>

                    <ShortlistButton type="cruise" id={ this.props.internalId_s} className="cruise-driver--favorites" />

                    { !this.props.unbrandedCruise_b && this.renderLineLogo() }
                </div>


                <div className="cruise-driver--bottom-wrapper">
                    <a title={ this.props.name_s } className="cruise-driver--heading" href={ this.renderUrl() }>{ this.props.name_s }</a>
                    <p className="cruise-driver--info">
                        { !this.props.unbrandedCruise_b && <span><i className="info-list--icon fa fa-ship" />{ this.props.shipName_s }</span> }
                        <span><i className="info-list--icon fa fa-calendar-alt" />{ this.renderDate() }</span>
                        <span><i className="info-list--icon fa fa-moon" />{ this.props.nights_i } nights</span>
                        { 'noFly_b' in this.props  && <span><i className="info-list--icon fa fa-plane" />{this.props.noFly_b ? 'No-Fly Cruise' : 'Fly Cruise' }</span> }
                        { this.props.flightsIncluded_b && <span><i className="icn icn-tick icn-tick-bold" />Flights Included</span> }
                        <span><i className="info-list--icon fa fa-anchor" />{ this.props.departurePort_s }</span>
                    </p>

                    <div className="cruise-driver--included">{ this.renderIncluded() }</div>

                    <div className="cruise-driver--itinerary-large">
                        <strong>Itinerary: </strong>
                        { this.props.itinerary_s ? this.props.itinerary_s.replace('&hellip;', '...') : ''  }
                    </div>

                    <a className="cruise-driver--itinerary" href={ this.renderUrl()+'#itinerary-timeline' } >View Itinerary</a>

                    { this.renderPrice() }

                    <a className="cruise-driver--button button" title={`View Cruise ${this.props.name_s} Deal`} href={ this.renderUrl() }>View Cruise Deal </a>
                </div>
            </div>
        );
    }
}